import { IconPlus, IconSearch } from "@tabler/icons-react";
import { AppConstant, LangConstant } from "const";
import { useTranslation } from "react-i18next";

const CHANNEL_SIZE_OPTIONS = [
  { value: "all", labelKey: LangConstant.TXT_CHANNEL_SIZE_ALL },
  { value: "small", labelKey: LangConstant.TXT_CHANNEL_SIZE_SMALL },
  { value: "medium", labelKey: LangConstant.TXT_CHANNEL_SIZE_MEDIUM },
  { value: "large", labelKey: LangConstant.TXT_CHANNEL_SIZE_LARGE },
  { value: "veryLarge", labelKey: LangConstant.TXT_CHANNEL_SIZE_VERY_LARGE },
];

const ChannelActions = ({ onSearchChange, channelSize, onChannelSizeChange, onCreateChannel, groupType }) => {
  const { t: getLabel } = useTranslation();

  const handleChangeKeyword = event => {
    const keyword = event.target.value;
    onSearchChange(keyword);
  };

  const handleSizeChange = event => {
    onChannelSizeChange(event.target.value);
  };

  return (
    <div className="d-flex gap-2">
      <div className="input-group" style={{ maxWidth: 800, flex: 1 }}>
        <input
          type="text"
          className="form-control"
          name="keyword"
          placeholder={getLabel("TXT_SEARCH_CHANNEL_PLACEHOLDER")}
          onChange={handleChangeKeyword}
        />
        <span className="input-group-text">
          <IconSearch size={16} />
        </span>
      </div>

      <select
        className="form-select"
        style={{ maxWidth: 280 }}
        value={channelSize}
        onChange={handleSizeChange}
        aria-label={getLabel(LangConstant.TXT_CHANNEL_SIZE_FILTER)}
      >
        {CHANNEL_SIZE_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {getLabel(option.labelKey)}
          </option>
        ))}
      </select>

      <button className="btn btn-primary d-flex align-items-center gap-1" onClick={onCreateChannel}>
        <IconPlus size={16} />
        {groupType === "group"
          ? (getLabel("OBJ_CREATE_CHANNEL_DIALOG.submitGroup") || "Tạo nhóm")
          : getLabel(LangConstant.TXT_CREATE_CHANNEL)}
      </button>
    </div>
  );
};

export default ChannelActions;
